export type TrendRange = "week" | "month";

/** School-wide share of users active in the preceding 30 days, every six hours. */
const lastWeek = [
  72, 72.5, 72, 72.8, 73, 73.4, 73.2, 74, 74.6, 75.5, 76.2, 76.8, 77, 76.5, 74.8, 76.8, 77.6, 78.2, 78.5, 78,
  79, 80.4, 80.8, 81.5, 83,
] as const;

/** The same share, once a day over the last four weeks. */
const lastMonth = [
  64, 64.8, 65.2, 64.6, 66, 66.8, 67.5, 67, 68.4, 69, 68.6, 70.2, 71, 70.4, 71.8, 72.5, 72, 73.6, 74.2, 73.8,
  75.4, 76.8, 76.2, 77.5, 78.6, 79.4, 80.2, 81.6, 83,
] as const;

const lastDay = "2026-10-13";
const hour = 60 * 60 * 1000;
const day = 24 * hour;

export type TrendPoint = { at: Date; share: number };

/** One sample per value. Week: every 6 hours from Monday 5 Oct. Month: 18:00 each day. */
export function trendPoints(range: TrendRange): TrendPoint[] {
  const start = Date.parse(range === "week" ? "2026-10-05T00:00:00Z" : "2026-09-15T18:00:00Z");
  const step = range === "week" ? 6 * hour : day;
  return activeTrend(range).map((share, index) => ({ at: new Date(start + index * step), share }));
}

export const weekdayKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;

export function activeTrend(range: TrendRange): readonly number[] {
  return range === "week" ? lastWeek : lastMonth;
}

/** Dates under the month chart: one per week, oldest first. */
export function monthTicks(): Date[] {
  const last = new Date(`${lastDay}T00:00:00Z`).getTime();
  return [28, 21, 14, 7, 0].map((daysAgo) => new Date(last - daysAgo * day));
}
